import React, { useEffect, useState } from 'react';
import {
  appImagePublicSrc,
  getCachedAppImageUrl,
  peekCachedAppImageUrl,
  type AppImageFile,
} from '../../utils/appImageCache';

export function useCachedAppImageSrc(file: AppImageFile): string {
  const publicSrc = appImagePublicSrc(file);
  const [src, setSrc] = useState(() => peekCachedAppImageUrl(file) ?? publicSrc);

  useEffect(() => {
    let cancelled = false;
    setSrc(peekCachedAppImageUrl(file) ?? publicSrc);
    void getCachedAppImageUrl(file).then((url) => {
      if (cancelled) return;
      if (url) setSrc(url);
    });
    return () => {
      cancelled = true;
    };
  }, [file, publicSrc]);

  return src;
}

type CachedAppImageProps = {
  file: AppImageFile;
  className?: string;
  alt?: string;
};

const CachedAppImage: React.FC<CachedAppImageProps> = ({ file, className, alt = '' }) => {
  const src = useCachedAppImageSrc(file);
  return <img className={className} src={src} alt={alt} draggable={false} />;
};

export default CachedAppImage;
